/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VehicleCorporateCodeOutcome } from './VehicleCorporateCodeOutcome';
import {
    VehicleCorporateCodeOutcomeFromJSON,
    VehicleCorporateCodeOutcomeFromJSONTyped,
    VehicleCorporateCodeOutcomeToJSON,
    VehicleCorporateCodeOutcomeToJSONTyped,
} from './VehicleCorporateCodeOutcome';
import type { VehicleSearchStatus } from './VehicleSearchStatus';
import {
    VehicleSearchStatusFromJSON,
    VehicleSearchStatusFromJSONTyped,
    VehicleSearchStatusToJSON,
    VehicleSearchStatusToJSONTyped,
} from './VehicleSearchStatus';
import type { VehicleSummary } from './VehicleSummary';
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
    VehicleSummaryToJSONTyped,
} from './VehicleSummary';

/**
 * 
 * @export
 * @interface VehicleSearchResponse
 */
export interface VehicleSearchResponse {
    /**
     * Unique search ID for polling results
     * @type {string}
     * @memberof VehicleSearchResponse
     */
    searchId: string;
    /**
     * 
     * @type {VehicleSearchStatus}
     * @memberof VehicleSearchResponse
     */
    status: VehicleSearchStatus;
    /**
     * 
     * @type {Array<VehicleSummary>}
     * @memberof VehicleSearchResponse
     */
    items?: Array<VehicleSummary>;
    /**
     * The resolved pickup location code
     * @type {string}
     * @memberof VehicleSearchResponse
     */
    pickupLocation?: string;
    /**
     * The resolved dropoff location code (IATA or city code). May equal pickup_location for same-airport round-trips, or differ for one-way rentals.
     * @type {string}
     * @memberof VehicleSearchResponse
     */
    dropoffLocation?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleSearchResponse
     */
    pickupDatetime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VehicleSearchResponse
     */
    dropoffDatetime?: Date;
    /**
     * Travelport response time in milliseconds
     * @type {number}
     * @memberof VehicleSearchResponse
     */
    responseTimeMs?: number;
    /**
     * True when the user supplied a discount/promo code that the vendor rejected; the results shown are standard cash rates (the code was not applied). The client should tell the user their code was not accepted.
     * @type {boolean}
     * @memberof VehicleSearchResponse
     */
    discountCodeNotAccepted?: boolean;
    /**
     * 
     * @type {Array<VehicleCorporateCodeOutcome>}
     * @memberof VehicleSearchResponse
     */
    corporateCodeOutcomes?: Array<VehicleCorporateCodeOutcome>;
}



/**
 * Check if a given object implements the VehicleSearchResponse interface.
 */
export function instanceOfVehicleSearchResponse(value: object): value is VehicleSearchResponse {
    if (!('searchId' in value) || value['searchId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VehicleSearchResponseFromJSON(json: any): VehicleSearchResponse {
    return VehicleSearchResponseFromJSONTyped(json, false);
}

export function VehicleSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchId': json['search_id'],
        'status': VehicleSearchStatusFromJSON(json['status']),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(VehicleSummaryFromJSON)),
        'pickupLocation': json['pickup_location'] == null ? undefined : json['pickup_location'],
        'dropoffLocation': json['dropoff_location'] == null ? undefined : json['dropoff_location'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : (new Date(json['pickup_datetime'])),
        'dropoffDatetime': json['dropoff_datetime'] == null ? undefined : (new Date(json['dropoff_datetime'])),
        'responseTimeMs': json['response_time_ms'] == null ? undefined : json['response_time_ms'],
        'discountCodeNotAccepted': json['discount_code_not_accepted'] == null ? undefined : json['discount_code_not_accepted'],
        'corporateCodeOutcomes': json['corporate_code_outcomes'] == null ? undefined : ((json['corporate_code_outcomes'] as Array<any>).map(VehicleCorporateCodeOutcomeFromJSON)),
    };
}

export function VehicleSearchResponseToJSON(json: any): VehicleSearchResponse {
    return VehicleSearchResponseToJSONTyped(json, false);
}

export function VehicleSearchResponseToJSONTyped(value?: VehicleSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_id': value['searchId'],
        'status': VehicleSearchStatusToJSON(value['status']),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(VehicleSummaryToJSON)),
        'pickup_location': value['pickupLocation'],
        'dropoff_location': value['dropoffLocation'],
        'pickup_datetime': value['pickupDatetime'] == null ? value['pickupDatetime'] : value['pickupDatetime'].toISOString(),
        'dropoff_datetime': value['dropoffDatetime'] == null ? value['dropoffDatetime'] : value['dropoffDatetime'].toISOString(),
        'response_time_ms': value['responseTimeMs'],
        'discount_code_not_accepted': value['discountCodeNotAccepted'],
        'corporate_code_outcomes': value['corporateCodeOutcomes'] == null ? undefined : ((value['corporateCodeOutcomes'] as Array<any>).map(VehicleCorporateCodeOutcomeToJSON)),
    };
}

